import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const AdminLayout = ({ children, activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'settings', label: 'Site Settings', icon: 'Settings' },
    { id: 'skills', label: 'Skills expertise', icon: 'SatelliteDish' },
    { id: 'achievements', label: 'Achievements', icon: 'Award' },
    { id: 'testimonials', label: 'Testimonials', icon: 'Quote' },
    { id: 'projects', label: 'Projects', icon: 'Briefcase' },
    { id: 'blog', label: 'Blog articles', icon: 'FileText' },
    { id: 'resume', label: 'Resume', icon: 'Clipboard' },
    { id: 'research', label: 'Research & Publications', icon: 'BookOpen' },
  ];

  return (
    <div className="min-h-screen bg-background text-text-primary flex">
      {/* Sidebar */}
      <aside className="w-64 border-r border-white/10 bg-surface/50 backdrop-blur-xl flex flex-col h-screen sticky top-0">
        <div className="p-6 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
              <Icon name="Shield" size={18} className="text-white" />
            </div>
            <span className="font-heading font-bold text-xl tracking-tight">Admin Console</span>
          </div>
        </div>
        
        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-smooth group ${
                activeTab === tab.id 
                  ? 'bg-accent text-white shadow-lg shadow-accent/20' 
                  : 'text-text-secondary hover:bg-white/5 hover:text-text-primary'
              }`}
            >
              <Icon 
                name={tab.icon} 
                size={20} 
                className={activeTab === tab.id ? 'text-white' : 'text-text-secondary group-hover:text-accent'} 
              />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button 
            onClick={() => window.location.href = '/'}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-text-secondary hover:bg-white/5 transition-smooth"
          >
            <Icon name="ExternalLink" size={20} />
            <span>View Website</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8 lg:p-12 max-h-screen overflow-y-auto">
        <div className="max-w-5xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
